module.exports = __webpack_public_path__ + "static/media/logo.0461bff9.png";